var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_3576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1665 9.99998C19.1665 8.58331 18.1665 7.41663 16.8332 7.16663C17.5832 5.99996 17.4165 4.49994 16.4165 3.49994C15.4165 2.49994 13.9165 2.41661 12.7498 3.08327C12.4998 1.74994 11.3332 0.75 9.9165 0.75C8.49983 0.75 7.33317 1.74994 7.08317 3.08327C5.9165 2.33327 4.41651 2.49994 3.41651 3.49994C2.41651 4.49994 2.33317 5.99996 2.99984 7.16663C1.66651 7.41663 0.666504 8.58331 0.666504 9.99998C0.666504 11.4166 1.66651 12.5833 2.99984 12.8333C2.24984 14 2.41651 15.5 3.41651 16.5C4.41651 17.5 5.9165 17.5834 7.08317 16.9167C7.33317 18.25 8.49983 19.25 9.9165 19.25C11.3332 19.25 12.4998 18.25 12.7498 16.9167C13.9165 17.6667 15.4165 17.5 16.4165 16.5C17.4165 15.5 17.4998 14 16.8332 12.8333C18.1665 12.5833 19.1665 11.4166 19.1665 9.99998Z",
    stroke: "#414446",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 7.41675L9.1665 12.4167L6.6665 9.91675",
    stroke: "#414446",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_3576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/Offers.9d477da057b82b6dd21976828de9429c.svg";
export { ForwardRef as ReactComponent };